import React, { Component } from 'react';
import {
  NormalButton,
  PushButton,
} from '../components';
import {
  inject,
  observer,
} from 'mobx-react';
import { OUTPUT_TTL } from '../../../constants/Pac';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import Counter, { formatSeconds } from '../../Counter/Counter';
import {
  Sound,
  Sounds,
} from '../../Sound';
import Toggle from 'react-toggle';
import { IconUnitLabel } from '../components/labels';
import {
  AnalogIconList,
  AnalogUnitList,
} from '../../../constants/DeviceModels';

@inject('batchStore', 'devicesStore')
@observer
class StationaryMixer extends Component {

  render() {
    const { device, batchStore, devicesStore } = this.props;
    const isOpenOff = batchStore.isInputPortOff(device.openTiltStatusPNo);
    const isCloseOff = batchStore.isInputPortOff(device.closeReturnStatusPNo);
    const isOn = batchStore.isOutputOn(device.mixerOnPNo);
    const name = device.description || `S Mixer #${device.id}`;
    let mixerDataStatus = batchStore.getDeviceStatus(device.id);
    const error = mixerDataStatus.error ? 'error' : '';
    const active = isOn ? 'active' : '';
    let gate = '', countDownOn = mixerDataStatus.status !== DeviceStatus.IDLE;
    const { uid, tId, currentDrop, allDrops, truckCode } = mixerDataStatus;
    const mCode = uid ? `${truckCode || tId || uid} ${currentDrop}/${allDrops}` : '';
    const inputDisabled = batchStore.isInputDisabled(device.openTiltStatusPNo) || batchStore.isInputDisabled(device.closeReturnStatusPNo)
      ? 'device-input-disabled' : '';
    const isDisabled = device.diverterPNo ? batchStore.isOutputOn(device.diverterPNo) : false;
    const disabled = isDisabled ? 'disabled' : '';
    const analogInput = device.analogInputId ? devicesStore.devices.find(v => v.id === device.analogInputId) || {} : {};

    if (!isOpenOff && isCloseOff) {
      gate = 'gate-open';
    } else if (isOpenOff && isCloseOff) {
      gate = 'gate-half-open';
    } else if (isOpenOff && !isCloseOff) {
      gate = 'gate-close';
    } else if (!isOpenOff && !isCloseOff) {
      gate = 'device-error';
    }

    const onCountDown = (data) => {
      mixerDataStatus = batchStore.getDeviceStatus(device.id);
      let s = {
        ...mixerDataStatus,
        currentCount: mixerDataStatus.status === DeviceStatus.END_MIXING ? 0 : data.seconds,
        restart: false,
      };

      if (mixerDataStatus.status === DeviceStatus.MIXING && isCloseOff) {
        s.status = DeviceStatus.END_MIXING;
      } else if (mixerDataStatus.status === DeviceStatus.END_MIXING && !isOpenOff && isCloseOff) {
        s.status = DeviceStatus.TOP_OPEN;
        s.delay = device.topOpenTime;
        s.restart = true;
      } else if (mixerDataStatus.status === DeviceStatus.TOP_OPEN && data.seconds >= 0 && !mixerDataStatus.restart) {
        s.status = DeviceStatus.RETURNING;
        s.delay = 0;
        s.restart = true;
      } else if (mixerDataStatus.status === DeviceStatus.RETURNING && !isCloseOff) {
        s.status = DeviceStatus.CLOSE_DELAY;
        s.delay = device.downCloseDelay;
        s.restart = true;
      } else if (mixerDataStatus.status === DeviceStatus.CLOSE_DELAY && data.seconds >= 0 && !mixerDataStatus.restart) {
        s.status = DeviceStatus.FINISH;
        s.restart = false;
        s.currentCount = 0;
      }

      batchStore.deviceStatus.set(device.id, s);

    };

    return (
      <div id={`device-${device.id}`} className={`${disabled} ${active} ${gate} device-gui device-gui--stationary-mixer device-${error} ${inputDisabled}`}>
        <Sound file={Sounds.horn} play={mixerDataStatus.restart} />
        {device.analogInputId && (
          <IconUnitLabel value={batchStore.getAnalogInputValue(device.analogInputId)}
            unit={analogInput.unit || AnalogUnitList['%']}
            icon={analogInput.icon || AnalogIconList.DROP}/>
        )}
        <div className="device-label">
          <div className="device-type" title={`#${device.id} ${inputDisabled}`}>
            {inputDisabled ? <i className="fa fa-warning"/> : ''} {name}
          </div>
          <div className="status">{mixerDataStatus.status}</div>
          <div className="device-timer">
            {
              batchStore.replayMode
                ? formatSeconds(mixerDataStatus.currentCount)
                :
                (
                  <Counter delay={mixerDataStatus.delay}
                    currentCount={mixerDataStatus.currentCount}
                    onChange={onCountDown}
                    start={countDownOn}
                    restart={mixerDataStatus.restart}
                  />
                )
            }
          </div>
          {mCode && <div className="mix" title={mCode}>{mCode}</div>}
          {device.mixerOnPNo && (
            <NormalButton className={`btn-on btn-batch ${isOn ? 'active btn-batch-red' : 'btn-batch-green'}`}
              port={device.mixerOnPNo}
              duration={isOn ? '0' : OUTPUT_TTL}
              onClick={() => batchStore.rampUpMixer(device.id, !isOn)}
            >
              <i className="fa fa-power-off"/>
            </NormalButton>
          )}
        </div>
        <div className="device-icon barrels"/>
        <div className="device-icon engine"/>
        <div className="device-icon gate gate-left"/>
        <div className="device-icon gate gate-right"/>
        <div className="device-icon star star-left"/>
        <div className="device-icon star star-right"/>

        <div className="device-gui__row">
          {!batchStore.running.length && device.diverterPNo && (
            <div className="toggle-disable">
              <Toggle checked={!isDisabled} onChange={() => {
                batchStore.setOutput(device.diverterPNo, !isDisabled ? OUTPUT_TTL : '0');
              }}/>
            </div>
          )}
          <PushButton className="btn-batch btn-batch-red"
            port={device.closeReturnPNo}
            onPush={() => {
              batchStore.setOutput(device.closeReturnPNo, OUTPUT_TTL);
            }}>
            <i className="fa fa-arrow-up" />
          </PushButton>
          <PushButton className="btn-batch btn-batch-green"
            disabled={batchStore.mixerDownButtonShouldBeDisabled}
            port={device.openTiltPNo}
            onPush={() => {
              batchStore.setOutput(device.openTiltPNo, OUTPUT_TTL);
            }}>
          </PushButton>
        </div>
      </div>
    );
  }
}

export default StationaryMixer;
